import { CancelTokenSource } from 'axios';
import { PatientDocumentDto, UpsertPatientDocumentDto } from 'ts-types/api.types';
import axios from 'services/http';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/patient-documents`;

export const getAllPatientDocuments = (source: CancelTokenSource): Promise<Array<PatientDocumentDto>> => {
  return axios
      .get(`${apiUri}/`, {cancelToken: source.token})
      .then(response => response.data);
};

export const initialPatientDocument = (source: CancelTokenSource): Promise<UpsertPatientDocumentDto> => {
  return axios
      .get(`${apiUri}/initial`, {cancelToken: source.token})
      .then(response => response.data)
};

export const findPatientDocumentById = (id: number, source: CancelTokenSource): Promise<UpsertPatientDocumentDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const addPatientDocument =
    (upsertPatientDocumentDto: Partial<UpsertPatientDocumentDto>, source: CancelTokenSource)
        : Promise<PatientDocumentDto> => {
      return axios
          .post(apiUri, upsertPatientDocumentDto, {cancelToken: source.token})
          .then(response => response.data);
    };

export const editPatientDocument =
    (id: number, upsertPatientDocumentDto: Partial<UpsertPatientDocumentDto>, source: CancelTokenSource)
        : Promise<PatientDocumentDto> => {
      return axios
          .put(`${apiUri}/${id}`, upsertPatientDocumentDto, {cancelToken: source.token})
          .then(response => response.data);
    };

export const deletePatientDocument = (id: number, source: CancelTokenSource): Promise<PatientDocumentDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};
